// Cor por CATEGORIA (não por agente): com 40+ nós, paleta por agente vira
// arco-íris ilegível — a identidade individual fica no emoji + nome do nó;
// a cor codifica o grupo. 4 categorias + neutro pra desconhecidos.
export const CATEGORIES = {
  produto: { label: 'Produtos Simples Media', color: '#3987e5' }, // azul
  nau: { label: 'NAU', color: '#9085e9' }, // violeta
  cliente: { label: 'Clientes & negócios', color: '#d95926' }, // laranja
  pessoal: { label: 'Pessoal & labs', color: '#199e70' }, // aqua
};

const FALLBACK_COLOR = '#898781'; // ink-muted — desconhecidos/fora do registry

// compat: alguns módulos ainda importam PALETTE pra chips avulsos
export const PALETTE = Object.values(CATEGORIES).map((c) => c.color);

/**
 * Carrega o registry.json e monta um índice por endereço (lowercase);
 * a cor vem da categoria do agente (fixa, nunca re-atribuída).
 */
export async function loadRegistry() {
  const res = await fetch('/registry.json');
  const raw = await res.json();

  const byAddress = new Map();
  const deployerAddresses = new Set();

  for (const [name, info] of Object.entries(raw.agents ?? {})) {
    const address = info.address.toLowerCase();
    // carteiras v1 (migradas em 13/10/2026) continuam no histórico: mesmo agente
    const legacy = info.legacyAddress ? info.legacyAddress.toLowerCase() : null;
    if (name === 'deployer') {
      deployerAddresses.add(address);
      if (legacy) deployerAddresses.add(legacy);
      continue;
    }
    const cat = CATEGORIES[info.category] ?? null;
    byAddress.set(address, {
      name,
      address,
      emoji: info.emoji ?? '🤖',
      role: info.role ?? '',
      category: info.category ?? 'desconhecido',
      color: cat?.color ?? FALLBACK_COLOR,
    });
    if (legacy) byAddress.set(legacy, { ...byAddress.get(address), address: legacy, legacy: true });
  }

  return {
    network: raw.network,
    chainId: raw.chainId,
    byAddress,
    deployerAddresses,
  };
}

/**
 * Devolve (ou cria) a entrada de um agente desconhecido (endereço fora do
 * registry) — cinza neutro, identidade pelo endereço curto.
 */
export function resolveAgent(registry, address) {
  const addr = address.toLowerCase();
  let agent = registry.byAddress.get(addr);
  if (agent) return agent;

  agent = {
    name: shortAddressName(addr),
    address: addr,
    emoji: '🤖',
    role: 'Agente desconhecido (fora do registry)',
    category: 'desconhecido',
    color: FALLBACK_COLOR,
  };
  registry.byAddress.set(addr, agent);
  return agent;
}

function shortAddressName(addr) {
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}
